import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import Header from './layout/Header';
import Footer from './layout/Footer';
import MetaHelmet from './metaHelmet';
import Service from './../service';
import 'bootstrap/dist/css/bootstrap.min.css';

const api = new Service();

const FALLBACK_TITLE = 'Investors - Move It';
const FALLBACK_DESCRIPTION = 'Move It has built an award-winning, asset-light technology marketplace that is changing how people and businesses access moving, delivery, and on-demand labor.';

const Investors = (props) => {
    const [config] = useState(props.config);
    const [metaDetail, setMetaDetail] = useState({});

    const GetMetaDetail = () => {
        api.getApi('getMetaByPageName', { page_name: '/investors' }).then(response => {
            if (response && response.record) {
                setMetaDetail(response.record);
            }
        }).catch(() => {
            // Fallback meta below is fine if admin record is missing
        });
    };

    useEffect(() => {
        GetMetaDetail();
    }, []);

    useEffect(() => {
        const title = metaDetail.meta_title || FALLBACK_TITLE;
        document.title = title;
        if (window.gtag && config.G_TAG) {
            window.gtag('config', config.G_TAG, {
                page_title: title,
                page_path: window.location.pathname,
            });
        }
    }, [metaDetail, config]);

    const pageTitle = metaDetail.meta_title || FALLBACK_TITLE;
    const pageDescription = metaDetail.meta_description || FALLBACK_DESCRIPTION;

    return (
        <>
            <MetaHelmet title={pageTitle} description={pageDescription} />
            <Header></Header>
            <main className="investors-page">
                <section className="hero clean" style={{ backgroundImage: `url("web/img/about-top.jpg")` }}>
                    <article>
                        <div className="grid">
                            <div className="unit-2-3 unit-1-1-md">
                                <h1 className="h2 f-46">Invest in the Future of Moving &amp; On-Demand Logistics</h1>
                            </div>
                        </div>
                    </article>
                </section>

                <section className="slate padding-bottom-none">
                    <article>
                        <div className="grid grid-center">
                            <div className="unit-2-3 unit-1-1-md investors-copy">
                                <p>
                                    Move It has built an award-winning, asset-light technology marketplace that is changing how people and businesses access moving, delivery, and on-demand labor. Our platform connects customers with a growing network of independent truck owners and skilled labor, creating a highly scalable model without the capital burden of owning a traditional fleet.
                                </p>
                                <p>
                                    With our technology built, a proven operating model, growing traction across multiple U.S. markets, and demand extending beyond our current footprint, Move It is positioned for significant national growth. We believe the opportunity goes far beyond moving — our vision is to make Truck &amp; Muscle Anytime You Need It™ a nationally recognized category and Move It the platform that defines it.
                                </p>
                                <p>
                                    We are selectively engaging with investors and strategic partners who recognize the scale of this opportunity and want to be part of our next stage of growth. For confidential investment or strategic inquiries, contact us to learn more.
                                </p>
                            </div>
                        </div>
                    </article>
                </section>

                <section className="about-middle-content padding-top-none">
                    <div className="container">
                        <div className="highlights">
                            <div className="highlight">
                                <div className="image">
                                    <img src="web/img/about-1.jpg" alt="Asset-light marketplace" />
                                </div>
                                <div className="content">
                                    <div className="content-container">
                                        <h3 className="h5 mb-2">Asset-Light Marketplace</h3>
                                        <p className="mb-0">
                                            An award-winning technology platform that connects customers with independent truck owners and skilled labor — scalable without owning a traditional fleet.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="highlight">
                                <div className="image">
                                    <img src="web/img/about-2.jpg" alt="Proven traction" />
                                </div>
                                <div className="content">
                                    <div className="content-container">
                                        <h3 className="h5 mb-2">Proven Traction</h3>
                                        <p className="mb-0">
                                            Technology built, a proven operating model, and growing traction across multiple U.S. markets with demand extending beyond our current footprint.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="highlight">
                                <div className="image">
                                    <img src="web/img/05.jpg" alt="National growth" />
                                </div>
                                <div className="content">
                                    <div className="content-container">
                                        <h3 className="h5 mb-2">National Growth</h3>
                                        <p className="mb-0">
                                            Positioned for significant national growth — making Truck &amp; Muscle Anytime You Need It™ a nationally recognized category.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="text-center investors-cta">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h2 className="f-46 mb-3">Ready to partner with Move It?</h2>
                                <p className="f-22 mb-4">For confidential investment or strategic inquiries, we&apos;d love to hear from you.</p>
                                <Link to="/contact-us" className="btn_submit">Contact us to learn more</Link>
                                <p className="mt-4 mb-0">
                                    Or email <a href="mailto:support@gomoveit.com">support@gomoveit.com</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer></Footer>
        </>
    );
};

export default Investors;
